// extracted by mini-css-extract-plugin
export default {"articlesSection":"views-EditorialPage-components-editorialArticles__articlesSection--z7D8p"};